export default "__VITE_ASSET__$GEAd1jL__"